/* ═══════════════════════════════════════════════════════════════
   CSV — the ONE place a table turns rows into a .csv file.

   RFC-4180 quoting (quote when the value holds a comma, quote,
   CR/LF or edge whitespace; embedded quotes are doubled), CRLF
   row endings, and a download that works identically on web and
   in Electron's renderer (Blob + object URL + synthetic anchor —
   the same pattern the timesheet export has always used).
   ═══════════════════════════════════════════════════════════════ */

export type CsvValue = string | number | boolean | null | undefined;

/** One RFC-4180 field. */
export function csvCell(value: CsvValue): string {
  if (value == null) return '';
  const s = String(value);
  if (/[",\r\n]/.test(s) || s !== s.trim()) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Header row + body rows → one CSV document. */
export function toCsv(headers: CsvValue[], rows: CsvValue[][]): string {
  const lines = [headers.map(csvCell).join(',')];
  for (const row of rows) lines.push(row.map(csvCell).join(','));
  return lines.join('\r\n');
}

/** Hands the user a .csv file. No dependency, no main-process round trip. */
export function downloadCsv(filename: string, csvText: string): void {
  const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** `projects-2026-09-23.csv` — the default name for a table export. */
export function csvFilename(base: string, when: Date = new Date()): string {
  const yyyy = when.getFullYear();
  const mm = String(when.getMonth() + 1).padStart(2, '0');
  const dd = String(when.getDate()).padStart(2, '0');
  return `${base}-${yyyy}-${mm}-${dd}.csv`;
}
